import { render, staticRenderFns } from "./task-order-detail.vue?vue&type=template&id=c04fdf72"
import script from "./task-order-detail.vue?vue&type=script&lang=js"
export * from "./task-order-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports